let url = "https://api.chinashipbd.com/v1/admin";
// let url = "http://192.168.0.106:3070/v1/admin";
export default url;
